var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-progress',{staticClass:"print-background",attrs:{"text-inside":true,"stroke-width":15,"percentage":_vm.params.value,"color":_vm.customColor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }